import axios from 'axios';

import { detect } from 'detect-browser';
const browser = detect();
const browserUID = (() => {
  const nav = window.navigator;
  const screen = window.screen;
  let guid = String(nav.mimeTypes.length);
  guid += nav.userAgent.replace(/\D+/g, '');
  guid += nav.plugins.length;
  guid += screen.height || '';
  guid += screen.width || '';
  guid += screen.pixelDepth || '';
  return guid;
})();

// auth http client using firebase token
const bHistory = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,

  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  data: {
    device_uid: browserUID,
    device_type: 'browser',
    device_platform: browser ? browser.os : 'unknown',
    device_os_version: (browser ? browser.name : 'unknown') + '_' + (browser ? browser.version : 'unknown'),
  },
});

const service = {
  http: bHistory,

  setToken(token: string) {
    this.http.defaults.headers.Authorization = 'token ' + token;
  },

  async getHistoryForClient(data: any) {
    data = data || { account_id: 0 };
    try {
      if (!data.account_id) {
        throw new Error('no account_id for history list');
      }
      const res = await this.http.post('/admin/account_history', data);
      return res.data.data;
    } catch (err) {
      throw err;
    }
  },
};

export default service;
